
<template>
  <!-- 寻样查询框 -->
  <el-form
    class="cml-search-form"
    ref="listForm"
    :model="filtersValue"
    :inline="true"
    :label-width="labelWidth"
    size="mini"
  >
    <div class="row">
      <div class="col">
        <el-form-item
          v-for="item in listForm.list"
          :key="item.prop"
          ref="formItem"
          :label="item.label"
          :prop="item.prop"
        >
          <template v-if="item.type === 'slot'"> </template>
          <template v-else>
            <component
              v-bind:is="item.tag"
              v-bind="item.bind"
              :value="filtersValue[item.prop]"
              v-model.trim="filtersValue[item.prop]"
              :type="item.type"
              :maxlength="item.maxlength"
              :disabled="item.disabled"
              clearable
              filterable
              size="mini"
              :autosize="item.autosize"
              :multiple="item.multiple"
              :range-separator="
                item.rangeSeparator ? item.rangeSeparator : '至'
              "
              :start-placeholder="
                item.startPlaceholder ? item.startPlaceholder : '开始日期'
              "
              :end-placeholder="
                item.endPlaceholder ? item.endPlaceholder : '结束日期'
              "
              :placeholder="item.placeholder ? item.placeholder : '请输入内容'"
              :format="item.format ? item.format : 'yyyy-MM-dd HH:mm:ss'"
              :value-format="
                item.valueFormat ? item.valueFormat : 'yyyy-MM-dd HH:mm:ss'
              "
              @keyup.13.native="handlerSearch"
              @change="handlerChange"
              @change-emit="value => (filtersValue[item.prop] = value)"
            >
              <slot v-if="item.tag === 'el-select'">
                <el-option
                  v-for="item in item.options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </slot>
            </component>
          </template>
        </el-form-item>
      </div>
      <!-- 按钮组 -->
      <div class="col">
        <el-form-item class="btns">
          <el-button type="primary" @click="handlerSearch">查询</el-button>
          <el-button type="primary" @click="clearSearch">清空</el-button>
          <el-button
            v-for="item in listForm.btns"
            :key="item.prop"
            :type="item.type ? item.type : ''"
            :disabled="item.disabled"
            :loading="item.loading"
            @click="handlerBtn(item.prop)"
            v-hasPermission="item.hasPermission ? item.hasPermission : ''"
            >{{ item.label }}</el-button
          >
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>
<script>
import DictSelect from '@/components/DictSelect';
export default {
  name: 'SampleSearchForm',
  components: { DictSelect },
  props: {
    listForm: {
      type: Object,
      default() {
        return {
          list: [],
          btns: [],
        };
      },
    },
    labelWidth: {
      type: String,
      default: '100px',
    },
  },
  data() {
    return {
      infoData: this.listForm.list,
      filtersValue: this.initFiltersValue(),
    };
  },
  watch: {
    listForm: {
      deep: true,
      handler(val) {
        return val.list ? (this.infoData = val.list) : (this.infoData = []);
      },
    },
  },
  computed: {},
  methods: {
    // 初始化form的值
    initFiltersValue() {
      if (!this.listForm.list) {
        return {};
      }
      const values = {};
      this.listForm.list.forEach(it => {
        values[it.prop] = it.defaultValue ? it.defaultValue : undefined;
      });
      return values;
    },
    // 查询
    handlerSearch() {
      this.$emit('handlerSearch', this.filtersValue);
    },
    // 动态按钮导出数据
    handlerBtn(btn) {
      this.$emit('handlerBtn', btn, this.filtersValue);
    },
    handlerChange() {
      this.$emit('handlerChange', this.filtersValue);
    },
    clearSearch() {
      for (let key in this.filtersValue) {
        this.filtersValue[key] = undefined;
      }
      this.$emit('clear-search');
    },
  },
};
</script>
<style lang="less" scoped>
.row {
  display: flex;
  .col {
    min-width: 300px;
  }
}
.btns {
  .el-button {
    margin-right: 10px;
    margin-left: 0;
  }
  .el-button:last {
    margin-right: 0;
  }
}
/deep/.el-range-editor.el-input__inner {
  padding: 2px 5px;
}
</style>
